import { Alert, Form, Input, message } from 'antd';
import { useRef, useState } from 'react';
import { convertOpportunityToLead } from '@/services/bff/opportunity.api';
import { BusinessModal } from '../business-modal';

export function OpportunityToLeadModal({
  opportunityUuid,
  onCancel,
  onSuccess,
}: {
  opportunityUuid: string;
  onCancel: () => void;
  onSuccess: (leadUuid: string) => void;
}) {
  const [form] = Form.useForm<{ reason: string }>();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();
  const [dirty, setDirty] = useState(false);
  const [confirmExit, setConfirmExit] = useState(false);
  const pending = useRef(false);
  const cancel = () => {
    if (pending.current) return;
    if (dirty) setConfirmExit(true);
    else onCancel();
  };
  const submit = async () => {
    if (pending.current) return;
    pending.current = true;
    try {
      const values = await form.validateFields();
      setSaving(true);
      setError(undefined);
      const result = await convertOpportunityToLead(opportunityUuid, {
        reason: values.reason.trim(),
      });
      message.success('已转为线索，原商机已关闭');
      onSuccess(result.leadUuid);
    } catch (e) {
      if (e instanceof Error) setError(e.message || '转换失败，请重试');
    } finally {
      pending.current = false;
      setSaving(false);
    }
  };
  return (
    <>
      <BusinessModal
        open
        title="转为线索"
        onCancel={cancel}
        onOk={() => void submit()}
        footer={undefined}
        okText="转为线索"
        cancelText="取消"
        confirmLoading={saving}
        cancelButtonProps={{ disabled: saving }}
        maskClosable={false}
        zIndex={1200}
      >
        <Alert
          type="info"
          showIcon
          title="原商机将关闭，客户、销售阶段和历史记录保留。新线索可继续跟进，再次转化时复用原客户。"
          style={{ marginBottom: 12 }}
        />
        {error ? (
          <Alert
            type="error"
            showIcon
            title={error}
            style={{ marginBottom: 12 }}
          />
        ) : null}
        <Form
          form={form}
          layout="vertical"
          onValuesChange={() => setDirty(true)}
        >
          <Form.Item
            name="reason"
            label="转换原因"
            rules={[
              { required: true, whitespace: true, message: '请填写转换原因' },
              { max: 500, message: '转换原因最多500字' },
            ]}
          >
            <Input.TextArea
              rows={4}
              maxLength={500}
              showCount
              disabled={saving}
              placeholder="说明为什么需要重新培育此商机"
            />
          </Form.Item>
        </Form>
      </BusinessModal>
      {confirmExit ? (
        <BusinessModal
          open
          title="放弃未保存的修改？"
          width="min(480px, calc(100vw - 48px))"
          zIndex={1300}
          footer={undefined}
          okText="放弃修改"
          cancelText="继续编辑"
          onOk={onCancel}
          onCancel={() => setConfirmExit(false)}
        >
          转换原因尚未提交。
        </BusinessModal>
      ) : null}
    </>
  );
}
